import {
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import {
  finalize,
  interval,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
  takeWhile,
  timer,
} from 'rxjs';
import { HistoryMediConsultComponent } from '../history-medi-consult/history-medi-consult.component';
import { FormBuilder, Validators } from '@angular/forms';
import { routes } from '../../../../shared/routes/routes';
import { DataService } from '../../../../shared/data/data.service';
import { PaginationService } from '../../../../shared/custom-pagination/pagination.service';
import { ApiService } from '../../../../api.service';
import { CommonService } from '../../../../shared/common/common.service';
import { generateRoomId } from '../../../../../utils/client-utils';

@Component({
  standalone: false,
  selector: 'app-medi-consult',
  templateUrl: './medi-consult.component.html',
  styleUrls: ['./medi-consult.component.scss'],
})
export class MediConsultComponent implements OnInit {
  showExclusivePopup: boolean = false;
  showNoPlanPopup: boolean = false;
  public pageSize = 10;
  public serialNumberArray: Array<number> = [];
  public totalData = 0;
  showFilter = false;
  proceedToPay: boolean = false;
  enterEcocashPIn: boolean = false;
  blockAccount: boolean = false;
  paymentMessage: any;
  tryLater: boolean = false;
  paymentStatus: any;
  recordListing: any = [];
  paging: number[] = [];
  dependentData: any = [];
  selected_id: any;
  formData: any = {};
  showApologies: boolean = false;
  completeTelemedSub: boolean = false;
  subDetail: any;
  currPage: number = 0;
  gridReady = false;
  rowData: any = [];
  currentRowSelectedIndex: any;
  checkEligibilityDetails: any;
  @ViewChild(HistoryMediConsultComponent)
  HistoryComponent!: HistoryMediConsultComponent;
  public searchDataValue = '';
  @ViewChild('agGrid') agGrid: AgGridAngular | any;
  public tooltipHideDelay = 2000;
  @ViewChild('filtertextbox') filtertext!: ElementRef;
  SerachedRow: number | undefined;
  selectedTabIndex = 0;
  private gridApi: any;
  private gridColumnApi: any;
  paginationPageSize = 10;
  pages: number[] = [];
  totalPages: number = 0;
  currentPage: number = 1;
  visiblePageCount = 5;
  totalRecords = 0;
  totalPage: number = 0;
  public tooltipShowDelay = 0;
  lastElementOfPage: number = 0;
  NoRecordsFound!: boolean;
  public routes = routes;
  pinForm: any;
  @ViewChildren('pinInput') pinInputs!: QueryList<ElementRef>;
  bookingId: any;
  bookingConfirmed: any = false;
  attemptsLeft: number = 2;
  IncorrectPin: boolean = false;
  showPin: boolean = false;
  ErrorPin: boolean = false;
  showSuccess: boolean = false;
  timeElapsed: number = 0;
  timer: any;
  timeoutLimit: number = 5 * 60 * 1000;
  alaCartPriceOption: boolean = false;
  subTelemedCount: number = 0;
  reachedSubTelemed: boolean = false;
  remark: any;
  showSymptoms = false;
  viewPrescriptionfile: any;
  showCongratePopup: boolean = false;
  chatMessages: any[] = [];

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };
  colDefs: ColDef[] = [
    {
      headerName: 'S.NO',
      valueGetter: (params: any) => {
        const rowNode = params.node;
        const model = params.api.getModel();
        const allRows: any[] = [];
        model.forEachNodeAfterFilterAndSort((node: any) => {
          allRows.push(node);
        });
        const globalIndex = allRows.findIndex((node) => node === rowNode);
        return globalIndex + 1;
      },
      minWidth: 80,
      flex: 0.5,
      editable: false,
      resizable: false,
      filter: false,
      sortable: false,
      lockPosition: true,
    },
    {
      headerName: 'Patient Name',
      valueGetter: (params: any) => {
        const user = {
          first_name: params.data?.user_first_name || '',
          last_name: params.data?.user_last_name || '',
        };
        const displayName = this.commonService.getDisplayName(user);
        return displayName || 'N/A';
      },
      minWidth: 100,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
      flex: 1,
      cellStyle: { marginLeft: '-8px' },
    },
    {
      headerName: 'Number',
      field: 'phone_number',
      minWidth: 100,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
      flex: 1,
    },
    {
      headerName: 'Booking Date',
      valueGetter: (params: any) => {
        const rawDate =
          params.data?.booking_date !== 'N/A'
            ? params.data?.booking_date
            : params.data?.createdAt;
        const date = new Date(rawDate);
        if (isNaN(date.getTime())) return 'N/A';
        const formattedDate = date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          timeZone: 'Africa/Harare',
        });
        return `${formattedDate}`;
      },
      editable: false,
      resizable: true,
      minWidth: 110,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
      flex: 1,
      cellStyle: { marginLeft: '-8px' },
    },
    {
      headerName: 'Booking Time',
      valueGetter: (params: any) => {
        const bookingTime = params.data?.booking_time;
        const createdAt = params.data?.createdAt;

        if (bookingTime && bookingTime !== 'N/A') {
          return bookingTime;
        }

        if (createdAt) {
          const dateObj = new Date(createdAt);
          if (!isNaN(dateObj.getTime())) {
            let formattedTime = dateObj.toLocaleTimeString('en-GB', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
              timeZone: 'Africa/Harare',
            });
            formattedTime = formattedTime.replace(/am|pm/, (match) =>
              match.toUpperCase(),
            );
            return formattedTime;
          }
        }

        return 'N/A';
      },
      editable: false,
      resizable: true,
      minWidth: 120,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
      flex: 1,
      cellStyle: { marginLeft: '-8px' },
    },
    {
      headerName: 'Status',
      field: 'tc_booking_status',
      editable: false,
      resizable: true,
      minWidth: 160,
      filter: true,
      sortable: true,
      lockPosition: true,
      flex: 1,
      cellRenderer: (params: any) => {
        const status = params.data.tc_booking_status?.toLowerCase();
        const statusIcons: Record<string, string> = {
          cancelled: 'assets/img/telemedicine/cancelled.webp',
          completed: 'assets/img/ambulance/compelete.webp',
          request: 'assets/img/telemedicine/requested.webp',
          'done notes shared': 'assets/img/telemedicine/prescribed.webp',
          expired: 'assets/img/telemedicine/expired.webp',
          'in progress': 'assets/img/telemedicine/in-progress.webp',
          pending: 'assets/img/telemedicine/pending.webp',
          prescribed: 'assets/img/telemedicine/prescribed.webp',
          missed: 'assets/img/telemedicine/requested.webp',
          'pending payment': 'assets/img/telemedicine/payment-pending.webp',
        };
        const displayTextMap: Record<string, string> = {
          request: 'Requested',
          missed: 'Requested',
        };
        const toTitleCase = (str: string) =>
          str
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
        const iconUrl = statusIcons[status] || '';
        const displayValue = displayTextMap[status] || toTitleCase(status);
        return `
        <span style="display: flex; align-items: center; gap: 6px;">
          <img src="${iconUrl}" alt="${status}" style="width: 17px; height: 17px;" />
          <span style="text-transform: capitalize; color: black !important;">${displayValue}</span>
        </span>`;
      },
    },
    {
      headerName: 'Action',
      lockPosition: true,
      resizable: false,
      sortable: false,
      suppressMenu: true,
      minWidth: 175,
      flex: 1,
      cellRenderer(params: any) {
        const bookingDateValue = params.data.booking_date;
        const today = new Date();
        const rowIndex = params.node?.rowIndex;
        today.setHours(0, 0, 0, 0);

        const paymentStatus = params.data.ConsultAlaCartePayment?.payment_status
          ?.trim()
          ?.toLowerCase();
        const isValidBookingDate =
          bookingDateValue && !isNaN(new Date(bookingDateValue).getTime());
        let showPayNow = false;

        if (
          params.data.is_al_carte === 1 &&
          (params.data.ConsultAlaCartePayment === null ||
            (paymentStatus !== 'success' && paymentStatus !== 'in_progress'))
        ) {
          if (isValidBookingDate) {
            const bookingDate = new Date(bookingDateValue);
            bookingDate.setHours(0, 0, 0, 0);
            showPayNow = bookingDate >= today;
          } else {
            showPayNow = true;
          }
        }

        const showEdit = params.data.tc_booking_status == 'PENDING PAYMENT';

        const showReschedule =
          params.data.tc_booking_status === 'CANCELLED' ||
          params.data.tc_booking_status === 'PENDING';

        const container = document.createElement('div');

        if (showPayNow && params.data.tc_booking_status != 'EXPIRED') {
          const payNowBtn = document.createElement('button');
          payNowBtn.className = 'pay-now button_class';
          payNowBtn.innerText = 'Pay Now';
          payNowBtn.title = 'Make payment';
          payNowBtn.style.marginRight = '10px';
          container.appendChild(payNowBtn);
        }

        const viewBtn = document.createElement('a');
        viewBtn.className = 'btn btn-sm bg-info-light edit-btn me-2';
        viewBtn.style.setProperty('background-color', '#B7D6Ed ', 'important');
        viewBtn.innerHTML = '<i class="fas fa-eye"></i>';
        viewBtn.title = 'View';
        viewBtn.setAttribute('data-bs-toggle', 'modal');
        viewBtn.addEventListener('click', () => {
          localStorage.setItem('currentRowIndex', rowIndex);
          params.context.componentParent.currentRowSelectedIndex = rowIndex;
          const detailData = params.data || {};
          sessionStorage.setItem('detailData', JSON.stringify(detailData));
          params.context.componentParent.router.navigate([
            routes.telemedidetail,
          ]);
        });
        container.appendChild(viewBtn);

        if (showEdit) {
          const editBtn = document.createElement('a');
          editBtn.className = 'btn btn-sm bg-primary-light edit-btn me-2';
          editBtn.style.setProperty(
            'background-color',
            '#B7D6Ed ',
            'important',
          );
          editBtn.innerHTML =
            '<i class="fas fa-edit" style="color: black !important"></i>';
          editBtn.title = 'Edit';
          editBtn.setAttribute('data-bs-toggle', 'modal');
          editBtn.addEventListener('click', () => {
            const detailData = params.data || {};
            params.context.componentParent.openForm(detailData, true);
          });
          container.appendChild(editBtn);
        }

        if (showReschedule) {
          const rescheduleBtn = document.createElement('a');
          rescheduleBtn.className = 'btn btn-sm bg-warning-light edit-btn me-2';
          rescheduleBtn.style.setProperty(
            'background-color',
            '#B7D6Ed  ',
            'important',
          );
          rescheduleBtn.innerHTML = '<i class="fas fa-clock"></i>';
          rescheduleBtn.title = 'Reschedule Appointment';
          rescheduleBtn.setAttribute('data-bs-toggle', 'modal');
          rescheduleBtn.addEventListener('click', () => {
            const detailData = params.data || {};
            params.context.componentParent.openForm(detailData);
          });
          container.appendChild(rescheduleBtn);
        }

        if (params.data.prescriptionDetail) {
          const prescriptionDetailBtn = document.createElement('a');
          const img = document.createElement('img');
          img.src = 'assets/img/telemedicine/viewprescribe.webp';
          img.alt = 'Prescription';
          img.style.width = '47px';
          img.style.height = '47px';
          img.style.marginLeft = '-12px';
          prescriptionDetailBtn.append(img);
          prescriptionDetailBtn.title = 'Prescription';
          prescriptionDetailBtn.addEventListener('click', () => {
            const detailData = params.data || {};
            params.context.componentParent.showSymptomPopup(detailData);
          });
          container.appendChild(prescriptionDetailBtn);
        }

        const hideChat =
          params.data?.tc_booking_status == 'PENDING PAYMENT' ||
          params.data?.tc_booking_status == 'EXPIRED';

        if (!hideChat) {
          const chatBtn = document.createElement('a');
          chatBtn.className = 'btn btn-sm chat-btn me-2';
          chatBtn.innerHTML = '<i class="fas fa-comment"></i>';
          chatBtn.title = 'Chat';

          chatBtn.style.setProperty('background-color', '#B7D6Ed', 'important');
          chatBtn.style.padding = '6px 8px';
          chatBtn.style.borderRadius = '4px';

          chatBtn.addEventListener('click', () => {
            const detailData = params.data || {};
            params.context.componentParent.openChatPanel(detailData);
          });

          container.appendChild(chatBtn);
        }

        return container;
      },
      onCellClicked: (params: any) => {
        const target = params.event.target;
        const detailData = params.data || {};
        if (target.classList.contains('pay-now')) {
          if (detailData.slot_id && detailData.slot_id !== 'N/A') {
            this.moveTosubcription(detailData);
          } else {
            this.paymentStatus = detailData;
            this.bookingId = this.paymentStatus.tc_booking_id;
            this.teleSubsCounts('paynow');
          }
        }
      },
    },
  ];
  totalData2 = 0;
  pageRestored = false;
  userProfile: any = {};
  showApology = false;
  userSubscription: any = {};
  featureNames: any = [];
  is_al_carte: boolean = false;
  telemedicineFeature: any;
  reportIdToDelete: any;
  showDeleteModal: boolean = false;
  private destroy$ = new Subject<void>();
  tableData: any = [];
  slotUnavailable: boolean = false;
  responseStatusCode: any;
  billingNumber: any;
  chatData: any = null;
  isChatOpen: boolean = false;
  chatInitials: string = 'D';
  chat_text: string = '';
  ratingQA: any;

  constructor(
    private fb: FormBuilder,
    private data: DataService,
    private pagination: PaginationService,
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private cdr: ChangeDetectorRef,
  ) {
    this.pinForm = this.fb.group({
      pin0: ['', [Validators.required, Validators.pattern('[0-9]')]],
      pin1: ['', [Validators.required, Validators.pattern('[0-9]')]],
      pin2: ['', [Validators.required, Validators.pattern('[0-9]')]],
      pin3: ['', [Validators.required, Validators.pattern('[0-9]')]],
    });
  }
  reload(data?: any) {
    this.ngOnInit();
    this.userProfile = JSON.parse(localStorage.getItem('user') || '{}');
    const targetId = this.userProfile.user_id;
    this.HistoryComponent?.getReports(targetId);
  }
  ngOnInit() {
    this.userProfile = JSON.parse(localStorage.getItem('user') || '{}');
    this.subDetail = JSON.parse(localStorage.getItem('subDetail') || '{}');
    this.commonService.refreshParentDetailObserver$.subscribe((res) => {
      if (res == 'consultation') {
        this.getReports(this.userProfile.user_id);
      }
    });

    this.apiService
      .VerifyTentureStatus({
        feature_id: this.telemedicineFeature?.feature_id
          ? this.telemedicineFeature?.feature_id
          : 2,
        type: 'Consultant',
        user_id: this.userProfile.user_id,
      })
      .subscribe((res: any) => {
        localStorage.setItem('consult_status', String(res?.sub_tenure_status));
        localStorage.setItem('tenure_consult_status', JSON.stringify(res));
        this.is_al_carte = res?.sub_tenure_status;
      });
    this.getUserSubscription();
    this.getReports(this.userProfile.user_id);
    this.commonService.modalClosed$.subscribe((closed) => {
      if (closed) {
        this.getReports(
          this.selected_id ? this.selected_id : this.userProfile.user_id,
        );

        const isReached = this.subTelemedCount >= 12;
        if (isReached) this.completeTelemedSub = true;

        if (this.is_al_carte === false || isReached) {
          this.spinner.show();
          const getRecentEntry = sessionStorage.getItem('tele_consult_status');
          if (getRecentEntry) {
            try {
              const outerParse = JSON.parse(getRecentEntry);
              const item = JSON.parse(outerParse.data);
              const now = new Date().getTime();

              if (now > item.expiry) {
                sessionStorage.removeItem('tele_consult_status');
                this.spinner.hide();
                this.showApology = true;
              }
              const jsonData = {
                tc_booking_id: item.data.tc_booking_id ?? 'N/A',
                user_id: item.data.user_id ?? 'N/A',
                country_dial_code: item.data.country_dial_code ?? 'N/A',
                phone_number: item.data.phone_number ?? 'N/A',
                doctor_id: item.data.doctor_id ?? 'N/A',
                slot_id: item.data.slot_id ?? 'N/A',
                booking_date: item.data.booking_date ?? 'N/A',
                booking_time: item.data.booking_time ?? 'N/A',
                booking_channel_id: item.data.booking_channel_id ?? 'N/A',
                consultation_type: item.data.consultation_type ?? 'N/A',
                tc_plan_type: item.data.tc_plan_type ?? 'N/A',
                tc_booking_status: item.data.tc_booking_status ?? 'N/A',
                reason_for_consultation:
                  item.data.reason_for_consultation ?? 'N/A',
                channel_id: item.data.channel_id ?? 'N/A',
                prescription: item.data.prescription ?? 'N/A',
                is_al_carte: item.data.is_al_carte ?? 'N/A',
                a_la_carte_payment_id: item.data.a_la_carte_payment_id ?? 'N/A',
                consultation_notes: item.data.consultation_notes ?? 'N/A',
                created_by_user_id: item.data.created_by_user_id ?? 'N/A',
                updated_by_user_id: item.data.updated_by_user_id ?? 'N/A',
                is_deleted: item.data.is_deleted ?? 'N/A',
                deletedAt: item.data.deletedAt ?? 'N/A',
                createdAt: item.data.createdAt ?? 'N/A',
                updatedAt: item.updatedAt ?? 'N/A',
                user_first_name: item.data.user?.first_name ?? 'N/A',
                user_last_name: item.data.user?.last_name ?? '',
                user_phone: item.data.user?.phone ?? 'N/A',
                user_email: item.data.user?.email ?? 'N/A',
                user_profile: item.data.user?.profile ?? '',
                doctor_first_name: item.data.doctor?.first_name ?? 'N/A',
                doctor_last_name: item.data.doctor?.last_name ?? '',
                ConsultAlaCartePayment:
                  item.data.ConsultAlaCartePayment ?? null,
                medical: item?.data?.medical ?? [],
                payment_status:
                  item.data.ConsultAlaCartePayment?.payment_status ?? null,
                a_la_carte_price: item?.data.a_la_carte_price ?? 'N/A',
                currency: item?.data.payment_currency ?? 'N/A',
                prescriptionDetail: item?.data?.prescriptionDetail ?? null,
              };
              if (item.data.is_al_carte == 1) {
                if (jsonData?.ConsultAlaCartePayment === null) {
                  this.paymentStatus = jsonData;
                  this.bookingId = jsonData.tc_booking_id;
                  this.proceedToPay = true;
                  this.spinner.hide();
                } else if (
                  jsonData?.payment_status?.trim()?.toLowerCase() !=
                    'success' &&
                  jsonData?.payment_status?.trim()?.toLowerCase() !=
                    'in_progress'
                ) {
                  this.paymentStatus = jsonData;
                  this.bookingId = jsonData.tc_booking_id;
                  this.proceedToPay = true;
                  this.spinner.hide();
                }
              }
            } catch (error) {
              console.error('Failed to parse tele_consult_status:', error);
            }
          } else {
            this.spinner.hide();
            this.showApology = true;
          }
        } else {
          this;
          this.spinner.hide();
          this.showApology = true;
        }
        this.spinner.hide();
        this.commonService.reset();
      }
    });

    this.commonService.openChatPanel$.subscribe((data) => {
      if (data) {
        this.openChatPanel(data);
      }
    });
  }

  private mapBookingItem(item: any): any {
    return {
      tc_booking_id: item.tc_booking_id ?? 'N/A',
      user_id: item.user_id ?? 'N/A',
      country_dial_code: item.country_dial_code ?? 'N/A',
      phone_number: item.phone_number ?? 'N/A',
      doctor_id: item.doctor_id ?? 'N/A',
      slot_id: item.slot_id ?? 'N/A',
      booking_date: item.booking_date ?? 'N/A',
      booking_time: item.booking_time ?? 'N/A',
      booking_channel_id: item.booking_channel_id ?? 'N/A',
      consultation_type: item.consultation_type ?? 'N/A',
      tc_plan_type: item.tc_plan_type ?? 'N/A',
      tc_booking_status: item.tc_booking_status ?? 'N/A',
      reason_for_consultation: item.reason_for_consultation ?? 'N/A',
      channel_id: item.channel_id ?? 'N/A',
      prescription: item.prescription ?? 'N/A',
      is_al_carte: item.is_al_carte ?? 'N/A',
      a_la_carte_payment_id: item.a_la_carte_payment_id ?? 'N/A',
      consultation_notes: item.consultation_notes ?? 'N/A',
      created_by_user_id: item.created_by_user_id ?? 'N/A',
      updated_by_user_id: item.updated_by_user_id ?? 'N/A',
      is_deleted: item.is_deleted ?? 'N/A',
      deletedAt: item.deletedAt ?? 'N/A',
      createdAt: item.createdAt ?? 'N/A',
      updatedAt: item.updatedAt ?? 'N/A',
      user_first_name: item.user?.first_name ?? 'N/A',
      user_last_name: item.user?.last_name ?? 'N/A',
      user_gender: item.user?.gender ?? 'N/A',
      user_dob: item.user?.dob ?? '',
      user_phone: item.user?.phone ?? 'N/A',
      user_email: item.user?.email ?? 'N/A',
      user_profile: item.user?.profile ?? '',
      doctor_first_name: item.doctor?.first_name ?? 'N/A',
      doctor_last_name: item.doctor?.last_name ?? '',
      doctor_age: item.doctor?.dob ?? 'N/A',
      doctor_email: item.doctor?.email ?? 'N/A',
      doctor_speciality_name:
        item.doctor?.doctorDetails?.speciality_name ?? 'N/A',
      doctor_qualification: item.doctor?.doctorDetails?.qualification ?? 'N/A',
      ConsultAlaCartePayment: item.ConsultAlaCartePayment ?? null,
      prescriptionDetail: item?.prescriptionDetail ?? null,
      payment_status: item.ConsultAlaCartePayment?.payment_status ?? null,
      a_la_carte_price: item?.a_la_carte_price ?? 'N/A',
      currency: item?.payment_currency ?? 'N/A',
      medical: item?.medical,
    };
  }

  private getReports(id: any): void {
    this.apiService.getActiveTelemedicineConsultant(id).subscribe({
      next: (apiRes: any) => {
        this.rowData = (apiRes?.data ?? []).map((item: any) =>
          this.mapBookingItem(item),
        );
      },
      error: () => {},
    });
  }

  getFormattedDobWithAge(dob: string): string {
    if (!dob || dob === '0000' || dob.trim() === '') {
      return '';
    }

    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const birthDate = new Date(dob);

    if (isNaN(birthDate.getTime()) || birthDate.getFullYear() === 1970) {
      return '';
    }

    const today = new Date();
    const day = birthDate.getDate();
    const month = months[birthDate.getMonth()];
    const year = birthDate.getFullYear();

    let age = today.getFullYear() - year;
    const hasBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= day);

    if (!hasBirthdayPassed) {
      age -= 1;
    }

    return `${day} ${month} ${year}, ${age} years`;
  }

  getUserSubscription() {
    this.spinner.show();
    this.apiService.getUserSubscription().subscribe({
      next: (res: any) => {
        this.dependentData = [];
        const sub = res || {};
        this.telemedicineFeature = sub?.managePlanData?.find(
          (f: any) => f.feature_name === 'Telemedicine Consultations',
        );

        this.dependentData = (sub?.dependentData || [])?.map((d: any) => ({
          name:
            d?.dependentUser?.full_name?.trim() ||
            `${d?.dependentUser?.first_name || ''} ${
              d?.dependentUser?.last_name || ''
            }`.trim(),
          id: d?.dependentUser?.user_id,
        }));

        sub.userData.full_name ||= `${sub.userData.first_name || ''} ${
          sub.userData.last_name || ''
        }`.trim();
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      },
    });
  }

  selectTab(index: number, id: any) {
    this.selectedTabIndex = index;
    this.selected_id = index === 0 ? 0 : id;
    this.tableData = [];
    const targetId =
      this.selected_id !== 0 ? this.selected_id : this.userProfile.user_id;
    this.getReports(targetId);
    this.HistoryComponent.getReports(targetId);
  }

  closeEcoCashPin() {
    this.getReports(this.userProfile.user_id);
    this.pinForm.reset();
    this.enterEcocashPIn = false;
  }

  closeProceedPayment() {
    this.proceedToPay = false;
    this.slotUnavailable = false;
    this.getReports(this.userProfile.user_id);
  }

  onCheckEl() {
    this.showPin = false;
    this.billingNumber = this.userProfile.billing_number
      ? this.userProfile.billing_number
      : this.paymentStatus.phone_number;

    if (this.paymentStatus?.slot_id && this.paymentStatus?.slot_id !== 'N/A') {
      this.checkSlotAvailability(this.paymentStatus.slot_id, () => {
        this.continuePaymentFlow();
      });
      return;
    }

    this.continuePaymentFlow();
  }

  continuePaymentFlow() {
    if (this.is_al_carte == false || this.completeTelemedSub) {
      this.enterEcocashPIn = true;
      this.proceedToPay = false;
    } else {
      this.proceedToPay = false;
    }
  }
  onInput(index: number, event: any): void {
    const input = event.target;
    const value = input.value;

    if (!/^\d$/.test(value)) {
      input.value = '';
      return;
    }
    this.pinForm.get('pin' + index)?.setValue(value);
    setTimeout(() => {
      input.value = this.showPin ? value : '*';
    }, 10);
    const next = input.nextElementSibling;
    if (next) next.focus();
  }

  onKeyDown(index: number, event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = this.pinInputs.get(index - 1);
      prevInput?.nativeElement.focus();
    }
  }

  onSubmit(): void {
    if (!this.pinForm.valid) {
      Object.keys(this.pinForm.controls).forEach((control) =>
        this.pinForm.get(control)?.markAsTouched(),
      );
      return;
    }

    if (this.paymentStatus?.slot_id && this.paymentStatus?.slot_id !== 'N/A') {
      this.checkSlotAvailability(this.paymentStatus.slot_id, () => {
        this.proceedWithPinValidation();
      });
      return;
    }

    this.proceedWithPinValidation();
  }

  private proceedWithPinValidation(): void {
    this.spinner.show();

    const validatePin = () => {
      const pin = Object.values(this.pinForm.value).join('');
      const payload = {
        phone: this.billingNumber,
        userId: this.paymentStatus.user_id,
        bookingId: this.bookingId,
        alaCartePrice: this.paymentStatus.a_la_carte_price,
        channelId: this.paymentStatus.channel_id,
        paymentGateway: 'Ecocash',
        featureService: 'Telemedicine Consultations',
        currency: this.paymentStatus.currency || 'ZWG',
        userPin: pin,
      };

      this.apiService.pinValidate(payload).subscribe(
        (res: any) => {
          if (res.status) {
            this.responseStatusCode = res.data.responseCode;
            const getStatusMessage = res.message;
            this.paymentMessage = getStatusMessage;
            /**
             * Handles the EcoCash PIN validation response based on the status code received.
             *
             * Status Code Reference:
             * ---------------------------------------------------------------
             * "00"     → PIN successfully validated (booking confirmed)
             * "32012"  → PIN is required and must be exactly 4 digits
             * "20006"  → Incorrect PIN entered; one more failed attempt may block the account
             * "20001"  → Invalid mobile number or incorrect PIN
             * "20005"  → Account is currently blocked; user should reset PIN or contact support
             * "99033"  → MSISDN (mobile number) not registered for EcoCash services
             * "002100" → General error or unexpected failure (treated similarly to incorrect PIN)
             *
             * All error codes result in hiding the PIN input modal and displaying the appropriate
             * error or block message flags for UI handling.
             */
            switch (this.responseStatusCode) {
              case '00':
                // PIN validated successfully
                setTimeout(() => this.getAlaCarteDetails(), 0);
                break;

              case '32012':
                // Invalid PIN format (must be exactly 4 digits)
                this.IncorrectPin = true;
                this.enterEcocashPIn = false;
                break;

              case '20006':
                // Incorrect PIN; next failed attempt may block account
                this.blockAccount = true;
                this.enterEcocashPIn = false;
                break;

              case '20001':
                // Invalid mobile number or incorrect PIN
                this.ErrorPin = true;
                this.enterEcocashPIn = false;
                break;

              case '20005':
                // Account is blocked
                this.blockAccount = true;
                this.enterEcocashPIn = false;
                break;

              case '99033':
                // Mobile number not registered for EcoCash services
                this.ErrorPin = true;
                this.enterEcocashPIn = false;
                break;

              case '002100':
                // General or unknown error
                this.ErrorPin = true;
                this.enterEcocashPIn = false;
                break;

              default:
                // Fallback for unrecognized status codes
                this.ErrorPin = true;
                this.enterEcocashPIn = false;
            }

            this.pinForm.reset();
          } else {
            this.bookingConfirmed = false;
            this.enterEcocashPIn = false;
            this.attemptsLeft--;
            this.IncorrectPin = this.attemptsLeft > 0;
            this.ErrorPin = this.attemptsLeft <= 0;
            this.startTimer();
            this.pinForm.reset();
          }
          this.spinner.hide();
        },
        (err: any) => {
          this.bookingConfirmed = false;
          this.IncorrectPin = false;
          this.enterEcocashPIn = false;
          this.ErrorPin = true;
          this.spinner.hide();
          const message =
            err?.error?.message ||
            (err?.status === 0
              ? 'Unable to reach the payment service. Please check your connection and try again.'
              : 'PIN validation failed');
          this.toastrService.error(message);
          this.pinForm.reset();
        },
      );
    };

    if (this.attemptsLeft === 3) {
      validatePin();
    } else {
      validatePin();
    }
  }

  getAlaCarteDetails() {
    this.spinner.show();
    let inProgressExist: boolean = true;
    const polling$ = interval(1000).pipe(
      switchMap(() => this.apiService.getTelemedicineById(this.bookingId)),
      takeWhile((res: any) => {
        return (
          res?.data?.ConsultAlaCartePayment?.payment_status !== 'Success' &&
          res?.data?.ConsultAlaCartePayment?.payment_status !== 'Failed'
        );
      }, true),
      takeUntil(timer(10000)),
    );

    polling$.subscribe({
      next: (res: any) => {
        if (res?.data?.ConsultAlaCartePayment?.payment_status === 'Success') {
          this.spinner.hide();
          this.bookingConfirmed = 'success';
          this.enterEcocashPIn = false;
          inProgressExist = false;
        } else if (
          res?.data?.ConsultAlaCartePayment?.payment_status === 'Failed'
        ) {
          this.spinner.hide();
          this.enterEcocashPIn = false;
          inProgressExist = false;
          this.bookingConfirmed = 'failed';

          const rawRemark = res?.data?.ConsultAlaCartePayment?.remark || '';
          this.remark = rawRemark.replace(/^ProcessingException:/i, '').trim();
        } else {
          inProgressExist = true;
        }
      },
      error: (err: any) => {
        console.error('Error fetching AlaCarte details:', err);
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
        if (inProgressExist) {
          this.bookingConfirmed = 'progress';
          this.enterEcocashPIn = false;
        }
      },
    });
  }

  togglePinVisibility(): void {
    this.showPin = !this.showPin;

    this.pinInputs.forEach((inputRef, index) => {
      const input = inputRef.nativeElement;
      const value = this.pinForm.get('pin' + index)?.value;

      if (value) {
        input.value = this.showPin ? value : '*';
      }
    });
  }

  startTimer(): void {
    this.clearTimer();
    this.timeElapsed = 0;
    this.timer = setTimeout(() => {
      this.IncorrectPin = false;
      this.ErrorPin = true;
    }, this.timeoutLimit);
  }

  clearTimer(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  showSymptomPopup(detailData: any) {
    this.viewPrescriptionfile = detailData.prescriptionDetail;
    this.showSymptoms = true;
  }

  viewPrescription(viewPrescriptionfile: any) {
    this.openPdf(viewPrescriptionfile?.prescription_pdf_path);
    this.showSymptoms = false;
  }

  proceedToPays(event?: any): void {
    this.billingNumber =
      event || this.userProfile?.billing_number || this.userProfile?.phone;

    this.IncorrectPin = false;
    this.enterEcocashPIn = true;
    this.ErrorPin = false;
    this.responseStatusCode = null;
    this.pinForm.reset();
    this.clearTimer();
  }

  moveToHomeScreen() {
    this.ErrorPin = false;
    this.bookingConfirmed = false;
    this.IncorrectPin = false;
    this.proceedToPay = false;
    this.slotUnavailable = false;
    this.blockAccount = false;
    this.ErrorPin = false;
    this.attemptsLeft = 3;
  }

  allowOnlyDigits(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  goToHome() {
    this.bookingConfirmed = false;
    this.proceedToPay = false;
    this.slotUnavailable = false;
    location.reload();
    this.router.navigate([routes.telemedi]);
  }

  checkEligibility() {
    const isProfileValid = this.commonService.validateMandatoryProfileFields(
      this.userProfile,
    );

    if (!isProfileValid) {
      return;
    }

    this.spinner.show();
    this.apiService
      .VerifyTentureStatus({
        feature_id: this.telemedicineFeature?.feature_id
          ? this.telemedicineFeature?.feature_id
          : 2,
        type: 'Consultant',
        user_id: this.userProfile.user_id,
      })
      .subscribe(
        (res: any) => {
          localStorage.setItem(
            'consult_status',
            String(res?.sub_tenure_status),
          );
          this.alaCartPriceOption = res?.sub_tenure_status;
          localStorage.setItem('tenure_consult_status', JSON.stringify(res));
          if (res) {
            this.checkEligibilityDetails = res;
            if (res?.sub_tenure_status) {
              this.teleSubsCounts();
            } else {
              this.spinner.hide();
              this.initSubsForm();
            }
          } else {
            this.spinner.hide();
            setTimeout(() => {
              this.commonService.setModalData({
                alaCarteService:
                  localStorage.getItem('consult_status') === 'true',
                formData: {},
              });
              this.commonService.addModalClosed();
              document.getElementById('openAddTeleModal')?.click();
            }, 100);
          }
        },
        (err: any) => {
          this.spinner.hide();
          this.toastrService.error('Error checking eligibility');
        },
      );
  }

  teleSubsCounts(callFrom?: any) {
    this.completeTelemedSub = false;
    this.apiService.getSubTelemedCount(this.userProfile?.user_id).subscribe(
      (res: any) => {
        this.subTelemedCount = res?.data?.length;
        this.spinner.hide();

        if (this.subTelemedCount >= 12) {
          if (callFrom === 'paynow') {
            this.proceedToPay = true;
            this.completeTelemedSub = true;
          } else {
            this.reachedSubTelemed = true;
            this.showApologies = false;
          }
        } else if (callFrom === 'paynow') {
          this.proceedToPay = true;
          this.completeTelemedSub = true;
        } else {
          this.showCongratePopup = true;
          // this.initSubsForm();
        }
      },
      (err: any) => {
        this.spinner.hide();
        this.subTelemedCount = 0;
      },
    );
  }

  openForm(detailData: any = null, fromEditBtn: boolean = false) {
    this.formData = detailData || {};
    this.showExclusivePopup = false;
    this.showNoPlanPopup = false;
    this.showApologies = false;
    this.reachedSubTelemed = false;
    this.commonService.setModalData({
      alaCarteService: localStorage.getItem('consult_status') === 'true',
      formData: this.formData,
      backBtnInitiated: fromEditBtn,
    });
    setTimeout(() => {
      this.commonService.addModalClosed();
      document.getElementById('openAddTeleModal')?.click();
    }, 100);
  }

  openPdf(url: string) {
    if (!url) return;
    try {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.click();
    } catch (error) {
      console.error('Error opening PDF:', error);
    }
  }

  openDeleteConfirmation(reportId: any): void {
    this.reportIdToDelete = reportId;
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
    this.reportIdToDelete = null;
  }

  moveTosubcription(detailData: any) {
    this.paymentStatus = detailData;
    this.bookingId = this.paymentStatus.tc_booking_id;
    this.proceedToPay = false;
    this.slotUnavailable = false;
    this.spinner.show();
    this.apiService.getSlotCount(this.paymentStatus?.slot_id).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res && res?.success) {
          const countData = res?.data?.booking_counts;
          if (countData >= 0 && countData < 3) {
            this.teleSubsCounts('paynow');
          } else {
            this.slotUnavailable = true;
          }
        } else {
          this.toastrService.error(res?.message || 'Something went wrong!');
        }
      },
      (err: any) => {
        this.toastrService.error(err?.message || 'Something went wrong!');
        this.spinner.hide();
      },
    );
  }

  checkEnabledDisbaled() {
    return (
      JSON.parse(localStorage.getItem('user') || '{}').role === 'Dependent'
    );
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  upgradePlan() {
    this.showExclusivePopup = false;
    this.showNoPlanPopup = false;
    this.showApologies = false;
    localStorage.removeItem('category');
    this.router.navigate([routes.patientSubscription]);
  }

  initSubsForm() {
    this.reachedSubTelemed = false;
    this.showCongratePopup = false;
    if (
      this.checkEligibilityDetails?.plan === undefined ||
      this.checkEligibilityDetails?.plan === null
    ) {
      this.showNoPlanPopup = true;
      this.showExclusivePopup = false;
      this.showApologies = false;
      this.reachedSubTelemed = false;
      return;
    } else if (this.checkEligibilityDetails?.plan?.bundle_id === 1) {
      this.showExclusivePopup = true;
      this.showNoPlanPopup = false;
      this.showApologies = false;
      this.reachedSubTelemed = false;
      return;
    } else if (this.checkEligibilityDetails?.sub_tenure_status === false) {
      this.showApologies = true;
      this.showNoPlanPopup = false;
      this.showExclusivePopup = false;
      this.reachedSubTelemed = false;
      return;
    } else {
      setTimeout(() => {
        this.commonService.setModalData({
          alaCarteService: localStorage.getItem('consult_status') === 'true',
          formData: {},
        });
        this.commonService.addModalClosed();
        document.getElementById('openAddTeleModal')?.click();
      }, 100);
    }
  }

  checkSlotAvailability(slotId: string, onSuccess?: () => void): void {
    this.apiService.getSlotCount(slotId).subscribe(
      (res: any) => {
        if (res?.success) {
          const countData = res?.data?.booking_counts;

          if (countData >= 3) {
            this.slotUnavailable = true;
            this.proceedToPay = false;
            this.enterEcocashPIn = false;
            this.pinForm.reset();
            return;
          }

          if (onSuccess) {
            onSuccess();
          }
        }
      },
      () => {
        this.toastrService.error('Something went wrong!');
      },
    );
  }

  openChatPanel(data: any) {
    this.chatData = data;
    this.updateUIState();
    this.chatInitials = this.getInitials(data?.doctor_first_name);
    this.isChatOpen = true;
    this.chatMessages = [];

    const bookingId = data?.tc_booking_id;

    if (bookingId) {
      this.getChatMessages(bookingId);
    }

    localStorage.setItem('chatPanelBookingData', JSON.stringify(data));
  }

  closeChatPanel() {
    this.isChatOpen = false;
    localStorage.removeItem('chatPanelBookingData');
  }

  openFile(url: string): void {
    window.open(url, '_blank');
  }

  startVideoCallFromChat() {
    this.initiateCall('video');
  }

  private initiateCall(callMode: 'audio' | 'video'): void {
    if (!this.chatData) {
      this.toastrService.error('No booking data available');
      return;
    }

    const proceed = () => {
      const roomId = generateRoomId();
      this.closeChatPanel();
      const route =
        callMode === 'video' ? '/patients/video-room' : '/patients/audio-room';
      this.router.navigate([route, roomId], {
        state: { consultationData: this.chatData, callMode },
      });
    };

    const hasDoctorId =
      this.chatData.doctor_id &&
      this.chatData.doctor_id !== 'N/A' &&
      this.chatData.doctor_id !== null;

    if (hasDoctorId) {
      proceed();
      return;
    }

    const bookingId = this.chatData.tc_booking_id;
    this.spinner.show();
    this.apiService
      .assignDoctor({ tc_booking_id: bookingId })
      .pipe(
        switchMap(() =>
          this.apiService.getActiveTelemedicineConsultant(
            this.userProfile.user_id,
          ),
        ),
      )
      .subscribe({
        next: (apiRes: any) => {
          this.spinner.hide();
          const mapped = (apiRes?.data ?? []).map((item: any) =>
            this.mapBookingItem(item),
          );
          this.rowData = mapped;
          const updatedEntry = mapped.find(
            (item: any) => item.tc_booking_id === bookingId,
          );
          if (updatedEntry) {
            this.chatData = updatedEntry;
          }
          proceed();
        },
        error: () => {
          this.spinner.hide();
          this.toastrService.error(
            'Failed to assign doctor. Please try again.',
          );
        },
      });
  }

  getInitials(name: string): string {
    if (!name) return 'D';

    return name
      .split(' ')
      .map((word) => word.charAt(0))
      .join('')
      .substring(0, 2)
      .toUpperCase();
  }

  startAudioCall() {
    this.initiateCall('audio');
  }

  getChatMessages(bookingId: number) {
    this.chatMessages = [];

    this.apiService.getChatMessages(bookingId).subscribe({
      next: (res: any) => {
        if (res?.success && res?.data) {
          const chatList = res?.data?.messages || [];

          if (!chatList || chatList.length === 0) {
            this.chatMessages = [];
            return;
          }

          this.chatMessages = chatList.map((msg: any) => ({
            message: msg.message,
            from: msg.is_user_message == 1 ? 'me' : 'doctor',
            time: new Date(msg.createdAt).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            }),
            chatType: msg.chat_type,
            fileUrl: msg.file_url,
            fileName: msg.file_name,
          }));
        } else {
          this.chatMessages = [];
        }
      },
      error: (err) => {
        console.error('Failed to load chat messages', err);
      },
    });
  }

  reschedule(chatData: any) {
    this.openForm(chatData);
  }

  cancelAppointment() {
    this.commonService.setAppointment(this.chatData);

    const modal = new (window as any).bootstrap.Modal(
      document.getElementById('cancel_consultation'),
    );
    modal.show();
  }

  setReminder() {
    this.commonService.setAppointment(this.chatData);

    const modal = new (window as any).bootstrap.Modal(
      document.getElementById('set_reminder'),
    );
    modal.show();
  }

  rateExperience() {
    this.commonService.setAppointment(this.chatData);
    this.getRatingQuesAns();

    const modal = new (window as any).bootstrap.Modal(
      document.getElementById('rating_modal'),
    );
    modal.show();
  }

  getRatingQuesAns() {
    this.spinner.show();

    this.apiService
      .getRatingQA()
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (res: any) => {
          this.ratingQA = res?.data || [];
          this.commonService.setRatingQA(this.ratingQA);
        },
        error: (err: any) => {
          console.error('Error fetching rating QA:', err);
        },
      });
  }

  viewSummary() {
    this.commonService.setAppointment(this.chatData);

    const modal = new (window as any).bootstrap.Modal(
      document.getElementById('view_summary_modal'),
    );
    modal.show();
  }

  ngOnChanges() {
    if (this.chatData) {
      this.updateUIState();
    }
  }

  uiState: any = {
    canReschedule: false,
    canCancel: false,
    canSetReminder: false,
    canRate: false,
    title: 'Manage your appointment',
  };

  get status(): string {
    return this.chatData?.tc_booking_status?.toUpperCase() || '';
  }

  readonly STATUS_CONFIG = {
    editable: ['REQUEST', 'PENDING', 'CANCELLED'],
    cancel: ['REQUEST', 'PENDING'],
    reminder: ['REQUEST'],
    completed: ['COMPLETED', 'PRESCRIBED'],
  };

  updateUIState() {
    const status = (this.chatData?.tc_booking_status || '')
      .trim()
      .toUpperCase();

    this.uiState = {
      canReschedule: ['REQUEST', 'PENDING', 'CANCELLED'].includes(status),
      canCancel: ['REQUEST', 'PENDING'].includes(status),
      canSetReminder: ['REQUEST'].includes(status),
      canRate: ['COMPLETED', 'PRESCRIBED'].includes(status),
      title: ['COMPLETED', 'PRESCRIBED'].includes(status)
        ? 'Hope that was an effective consultation 😀'
        : 'Manage your appointment',
    };

    this.cdr.detectChanges();
  }
}
